<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Usuários</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="two wide field">
                  <label for="user-search-cod">Código</label>
                  <input
                    v-focus
                    type="text"
                    name="user-search-cod"
                    v-model="searchForm.cod"
                  />
                </div>
                <div class="six wide field">
                  <label for="user-search-description">Nome ou documento</label>
                  <input
                    type="text"
                    name="user-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="two wide field">
                  <label for="users-rule">Tipo de Usuário</label>
                  <select id="users-rule" v-model="searchForm.rule">
                    <option :value="null">Todos</option>
                    <option
                      v-for="(rule, index) in UserEnum.rules"
                      :key="index"
                      :value="rule.value"
                    >
                      {{ rule.description }}
                    </option>
                  </select>
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="users"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from '@/components/grid';
import UserEnum from '@/enumerations/user_enum';
import SearchMixins from '@/mixins/search_mixins';

export default {
  name: 'users',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      UserEnum: UserEnum,
      moreFilters: false,
      searchForm: {
        description: null,
        cod: null
      },
      query: {},
      gridColumns: [
        { description: null, kind: 'status', field: 'enable' },
        { description: null, kind: 'edit', field: 'id' },
        { description: 'Cod', field: 'id' },
        { description: 'Usuário', field: 'name' },
        { description: 'Tipo', field: 'rule' },
        { description: 'CPF / CNPJ', field: 'doc' }
      ]
    };
  },

  mounted() {
    this._initSearchForm();
    this.search(this.$route.query.page);
  },

  methods: {
    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          name_or_cpf_or_rg_or_cnpj_or_ie_cont: this.searchForm.description,
          id_eq: this.searchForm.cod,
          s: ['created_at desc']
        },
        page: page
      };

      if (this.searchForm.rule != null) {
        query.q.rule_eq = this.searchForm.rule;
      }

      this.$refs.grid.toggleLoading();
      Api.users
        .search(query)
        .then(async response => {
          response.data.users.forEach(user => {
            user.doc = user.cpf || user.cnpj;
            user.person = (
              UserEnum.persons.find(u => u.value == user.person) || {}
            ).description;
            user.rule = (
              UserEnum.rules.find(u => u.value == user.rule) || {}
            ).description;
          });

          this.$refs.grid.setItems(response.data.users);
          this.$refs.grid.setPaginate(response.data.pagination);
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
